import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content', 'full']
  static values = {
    moreText: String,
    lessText: String, 
    open: { type: Boolean, default: false }
  }

  toggle (event) {
    this.openValue === false ? this.show(event) : this.hide(event)
  }

  show (event) {
    this.openValue = true

    event.target.innerHTML = this.lessTextValue
    this.contentTarget.classList.remove("line-clamp-3")
  }

  hide (event) {
    this.openValue = false

    event.target.innerHTML = this.moreTextValue
    this.contentTarget.classList.add("line-clamp-3")
  }
}
